import './RejectionMessage.scss';

import { IconAlertErrorOutlined } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';
import type { ReactNode } from 'react';

import CreativeRejectionReasonsModal from '../../../../../StatusModal/CreativeRejectionReasonsModal/CreativeRejectionReasonsModal';
import type { CreativeFooterRejectedAsset, FooterCreativeData } from '../types';
type Props = {
  bodyText?: ReactNode;
  rejectedAssets: CreativeFooterRejectedAsset[];
  creative: FooterCreativeData;
};

const [block, element] = bem('rejection-message');

const RejectionMessage = ({ bodyText, creative, rejectedAssets }: Props): React.JSX.Element => {
  return (
    <div className={block()}>
      <IconAlertErrorOutlined className={element('error-svg')} />
      <div>
        {bodyText}
        {creative.rejectionReason && (
          <div>
            Rejection Reason: <span className={element('rejection-reason')}>{creative.rejectionReason}</span>
            {creative.rejectionReasonDetails && creative.rejectionReasonDetails.length > 1 && (
              <CreativeRejectionReasonsModal creative={creative} rejectedAssets={rejectedAssets} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RejectionMessage;
